import { createContext } from 'react';

import { FirebaseUser } from '../../providers';

/** TODO: Add types */
export const PageContext = createContext<{
    currentPageData: any;
    setCurrentPageData: any;
    currentUser: FirebaseUser | 'loading';
    setPageLoader: any;
}>(undefined!);
